export default function Title(title) {
  return `<div class="tm-c-title">${title}</div>`;
}
